document.addEventListener("DOMContentLoaded", function () {
  // Select all span elements that say "Add to cart"
  const addToCartSpans = document.querySelectorAll(
    '.quick-add__submit span:first-child'
  );

  addToCartSpans.forEach(function (span) {
    if (span.textContent.trim().toLowerCase() === "add to cart") {
      span.textContent = "+"; // Change the label
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".quick-add__submit");
  buttons.forEach(button => {
    if (button.textContent.includes("Choose options")) {
      button.textContent = "+";
    }
  });
});




//for PDP page variant and qunt. selector grid
  document.addEventListener("DOMContentLoaded", function () {
    const variantSelects = document.querySelector('#variant-selects-template--19203810951299__main');
    const quantityForm = document.querySelector('#Quantity-Form-template--19203810951299__main');

    // Check if elements exist and haven't already been wrapped
    if (variantSelects && quantityForm && !document.querySelector('#variant-quantity-wrapper')) {
      // Create a wrapper div
      const wrapper = document.createElement('div');
      wrapper.id = 'variant-quantity-wrapper';
      wrapper.style.display = 'grid';
      wrapper.style.gridTemplateColumns = '1fr 1fr';
      wrapper.style.gap = '16px'; // adjust spacing
      wrapper.style.alignItems = 'center'; // vertical alignment
      wrapper.style.margin = '12px 0'; // spacing around the block

      // Insert the wrapper before variantSelects
      variantSelects.parentNode.insertBefore(wrapper, variantSelects);
      
      // Move both elements inside the wrapper
      wrapper.appendChild(variantSelects);
      wrapper.appendChild(quantityForm);
    }
  });

  // made to order and new in badge 

(function() {
  const BADGES = [
    { tag: "made-to-order", text: "Made to Order", className: "made-to-order-label" },
    { tag: "new-in", text: "New Batch In Making", className: "made-to-order-label" }
  ];

  async function addLabelToCard(card) {
    if (card.dataset.labelDone) return;
    card.dataset.labelDone = "true";

    const productLink = card.querySelector("a[href*='/products/']");
    if (!productLink) return;

    const href = productLink.getAttribute("href").split("?")[0];
    const handle = href.split("/products/")[1];
    if (!handle) return;

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return;
      const product = await response.json();

      const tags = (Array.isArray(product.tags) ? product.tags : []).map(t => t.toLowerCase());

      const info = card.querySelector(".card__content");

      BADGES.forEach(({ tag, text, className }) => {
        if (!tags.includes(tag)) return;

        const label = document.createElement("div");
        label.className = className;
        label.textContent = text;

        if (info) {
          info.insertAdjacentElement("beforebegin", label);
        } else {
          card.appendChild(label);
        }
      });

    } catch (err) {
      console.warn("Badge label failed:", err);
    }
  }

  function processAllCards() {
    document.querySelectorAll(".card:not([data-label-done])").forEach(addLabelToCard);
  }

  document.addEventListener("DOMContentLoaded", () => {
    processAllCards();
    const observer = new MutationObserver(processAllCards);
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', processAllCards);
    document.addEventListener('shopify:section:reorder', processAllCards);
  });
})();